// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__lks4_","title":"AfterBackImages_title__OZTHb","images":"AfterBackImages_images__2Mr8g"};